export default __webpack_public_path__ + "static/media/Mobile home@2x.72aeb9e1.png";